import { useState } from "react";
import { BottomCTA, BottomSheet, IconBrick, TextField } from "@hamlak/ui";
import { t } from "@/i18n/ko";
import "./rerollSheet.css";

const DIRECTION_MAX = 150;

type Props = {
  open: boolean;
  /** 현재 모델의 rerollCost. 0 이면 CTA 에 가격 없이 "다시 생성"만 */
  cost: number;
  onSubmit: (direction: string) => void;
  onClose: () => void;
};

/** F03-21 답변 다시 생성 시트: 원하는 방향(선택·150자) + [다시 생성 [브릭] n] (가격은 CTA 문구 오른쪽, 0 이면 문구만 — AC0-233). */
export function RerollSheet({ open, cost, onSubmit, onClose }: Props) {
  const [direction, setDirection] = useState("");
  const close = () => {
    setDirection("");
    onClose();
  };
  return (
    <BottomSheet open={open} onClose={close} header={{ title: t("reroll.title"), description: t("reroll.description") }} data-testid="reroll-sheet">
      <div className="reroll__body">
        <TextField multiline rows={4} label={t("reroll.direction")} placeholder={t("reroll.direction.placeholder")} value={direction} onValueChange={setDirection} maxLength={DIRECTION_MAX} />
      </div>
      <BottomCTA
        fixed={false}
        primary={{
          // 접근 이름에 가격을 담는다 ("다시 생성 10브릭"). 0 이면 문구 그대로
          ...(cost > 0 ? { "aria-label": `${t("reroll.cta")} ${t("reroll.cost", { cost })}` } : {}),
          children:
            cost > 0 ? (
              <span className="reroll__cta">
                {t("reroll.cta")}
                <span className="reroll__ctaPrice" data-testid="reroll-price">
                  <IconBrick size={16} aria-hidden />
                  {cost}
                </span>
              </span>
            ) : (
              t("reroll.cta")
            ),
          onClick: () => {
            const d = direction;
            setDirection("");
            onSubmit(d);
          },
        }}
      />
    </BottomSheet>
  );
}
